import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import cx from 'classnames';
import useCurrentPage from '../../../../../../hooks/useCurrentPage';
import styles from '../Actions.scss';

const AppliedPromos = ({
  discountPlans,
  enablePublicDescription,
  reservationConfirmation,
}) => {
  const { primaryColorClass } = useCurrentPage();

  if (!enablePublicDescription) {
    return null;
  }

  const classes = cx(styles.appliedPromoText, primaryColorClass);

  // Function to format a single promo
  const formatPromo = (promo) => {
    const { publicDescription, requirementsText, endDate, description } = promo;
    if (!publicDescription && !description) { return ''; }

    const requirements = requirementsText ? `Required: ${requirementsText}` : '';
    const expiration = endDate ? `Expires: ${endDate}` : '';
    const separator = requirements && expiration ? ' - ' : '';
    const details = requirements || expiration
      ? ` [${requirements}${separator}${expiration}]`
      : '';

    return `${publicDescription || description}${details}`;
  };

  // Filter promos based on reservationConfirmation
  const promosToDisplay = discountPlans.filter((promo) => {
    if (reservationConfirmation) {
      // When reservation is confirmed, include promos with both publicDescription and description
      return promo.publicDescription || promo.description;
    }
    // Otherwise, include auto-applied promos with publicDescription
    return promo.autoApply && promo.publicDescription;
  });

  // Format the promos
  const formattedPromos = promosToDisplay
    .map(formatPromo)
    .filter(Boolean);

  if (!formattedPromos) {
    return null;
  }

  return (
    <div className={classes}>
      {formattedPromos.map(promo => (
        <div
          key={promo}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <span>{promo}</span>
          <span>Applied</span>
        </div>
      ))}
    </div>
  );
};

AppliedPromos.propTypes = {
  discountPlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  enablePublicDescription: PropTypes.bool.isRequired,
};

AppliedPromos.fragments = {
  discountPlan: gql`
    fragment AppliedPromosDiscountPlan on DiscountPlan {
      autoApply
      endDate
      publicDescription
      requirementsText
      description
    }
  `,
};

export default AppliedPromos;
